/// Random source shaped like Dart's `Random`, so the spawn logic ported from
/// enemy_manager.dart and the sky managers reads the same as the original.
///
/// Injecting it also makes the engine deterministic under test, which is how
/// the web port is checked against the Flutter numbers.

export interface Rng {
  /** Uniform in [0, 1). */
  nextDouble(): number;
  /** Uniform integer in [0, max). */
  nextInt(max: number): number;
}

export const defaultRng: Rng = {
  nextDouble: () => Math.random(),
  nextInt: (max) => Math.floor(Math.random() * max),
};

/// mulberry32: small, fast, and good enough for gameplay variety.
export function seededRng(seed: number): Rng {
  let state = seed >>> 0;

  const nextDouble = (): number => {
    state = (state + 0x6d2b79f5) >>> 0;
    let t = state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };

  return {
    nextDouble,
    nextInt: (max) => Math.floor(nextDouble() * max),
  };
}
